import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CloseCall } from './CloseCall'
import { MinimizeCall } from './MinimizeCall'
import { PIPButton } from '../GJKit/PIPButton'
import { TopNavBarContainer } from './Layout.styles'
import { FullScreenToggleButton } from './FullScreenButton'
import qs from 'qs'
import UtmUtils from '../../utils/utmUtils'
import { useUtm } from '@gojiraf/useutm'

export const TopNavBar = ({ isDesktop = false, isIframe = false, showPIPButton = false }) => {
  const [isFullscreen, setIsFullscreen] = useState(false)

  const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  const { utm_medium } = UtmUtils.getUtmObject(queryParams)
  const { allowFullScreen } = useUtm(utm_medium)

  return (
    <TopNavBarContainer isDesktop={isDesktop}>
      {!isDesktop && showPIPButton ? <PIPButton isMobile={!isDesktop} /> : null}
      {allowFullScreen && (
        <FullScreenToggleButton isFullscreen={isFullscreen} setIsFullscreen={setIsFullscreen} />
      )}
      {!isFullscreen && isIframe && <MinimizeCall />}
      {!isFullscreen && <CloseCall iframe={isIframe} />}
    </TopNavBarContainer>
  )
}

TopNavBar.propTypes = {
  isDesktop: PropTypes.bool,
  isIframe: PropTypes.bool,
  showPIPButton: PropTypes.bool,
}
